import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import useActiveTabFromParams from "@SearchResults/hooks/useActiveTabFromParams";
import RouteStatusType from "@Route/types/status/RouteStatus.type";
import {isEmpty} from "@Array/isEmpty";
import useFilterByPopularFilter from "./useFilterByPopularFilter";
import { useAppDispatch } from "@/hooks/dispatch/useAppDispatch";
import { setPopularFilter } from "@/pages/searchResults/reducers/filterSlice";
import { useEffect } from "react";

type PopularFilterType = {
    displayMTicketFilter: boolean,
    displayInstantConfirmationFilter: boolean,
    displayWebDiscountFilter: boolean,
    displayDirectRoutesFilter: boolean,
}

export default function useDisplayPopularFilters(searchData: SearchResultsRtkQueryResponseType): PopularFilterType {
    const activeTab = useActiveTabFromParams()
    const dispatch = useAppDispatch()
    const {
        filterByDirectRoutes,
        direct,
    } = useFilterByPopularFilter()

    const hasStatus = (statusKey: keyof RouteStatusType) => (
        searchData.result.singleRoutes[activeTab].some((route) => route.status[statusKey])
    )

    const hasWebDiscounts: boolean = searchData.result.singleRoutes[activeTab].some((route) => route.prices?.activeDiscount)
    const hasBusChangesOrIntermodalRoutes: boolean = !isEmpty(searchData.result.intermodalRoutes)
        || searchData.result.singleRoutes[activeTab].some((route) => !isEmpty(route.travelInfo.busChange) || route.travelInfo.busChangeCount !== 0)
    const hasDirectRoutes: boolean = searchData.result.singleRoutes[activeTab].some((route) => filterByDirectRoutes(route))

    useEffect(() => {
        if (hasDirectRoutes && !direct) {
            dispatch(setPopularFilter('direct'))
        }
    }, [searchData])

    return {
        displayMTicketFilter: hasStatus('hasMTicket'),
        displayInstantConfirmationFilter: hasStatus('isInstantConfirmation'),
        displayWebDiscountFilter: hasWebDiscounts,
        displayDirectRoutesFilter: hasBusChangesOrIntermodalRoutes,
    }
}